"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const json2csv_1 = require("json2csv");
const moment_1 = __importDefault(require("moment"));
const config_service_1 = require("../../../../../shared/config/config.service");
const users_service_1 = require("../../../../../shared/users/users.service");
const helper_1 = require("../../../@types/helper");
let ExportService = class ExportService {
    constructor(usersService, configService) {
        this.usersService = usersService;
        this.configService = configService;
        this.downloadCsv = (data, filename) => {
            const csvParser = new json2csv_1.Parser({
                delimiter: this.configService.getUserConfig(config_service_1.EUserSettings.CSV_COMPATABILITY) ? ';' : ',',
            });
            const csv = csvParser.parse(data);
            const a = document.createElement('a');
            document.body.appendChild(a);
            const file = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), csv], {
                type: 'text/csv;charset=utf8',
            });
            const fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = filename;
            a.click();
        };
        this.exportCsv = (data, filename) => {
            const dataToExport = [];
            data.forEach((d) => {
                const row = {};
                this.headers.forEach((h) => {
                    let value = (0, helper_1.getValueForPath)(d, h.traversal);
                    if (h.specialType === 'Date' && (0, moment_1.default)(String(value)).isValid()) {
                        value = (0, moment_1.default)(String(value)).format('DD.MM.YYYY');
                    }
                    if (h.specialType === 'UserId') {
                        value = this.usersService.getNameOfUser(value);
                    }
                    if (h.specialType === 'Exists' || h.specialType === 'Boolean') {
                        value = value ? 'Ja' : 'Nein';
                    }
                    if (h.specialType === 'Object_Array' && h.objectKey && value) {
                        value = value
                            .map((c) => c[h.objectKey || ''])
                            .join(' ');
                    }
                    row[h.header] = value || '';
                });
                dataToExport.push(row);
            });
            this.downloadCsv(dataToExport, filename);
        };
    }
};
ExportService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [typeof (_a = typeof users_service_1.UsersService !== "undefined" && users_service_1.UsersService) === "function" ? _a : Object, typeof (_b = typeof config_service_1.ConfigService !== "undefined" && config_service_1.ConfigService) === "function" ? _b : Object])
], ExportService);
exports.default = ExportService;
